import appLocaleData from 'react-intl/locale-data/vi';
import viMessages from '../locales/vi_VI';

const ViLang = {
  messages: {
    ...viMessages,
  },
  locale: 'vi-VI',
  data: appLocaleData,
};
export default ViLang;
